import { isNil } from 'lodash'
import { useFetchExplanationQuery } from '../../submission.api'
import { useAnswerContext } from '../../../../pages/assignment/components/text-submission-drawer/content/answers/answer/AnswerContext'
import { useFetchQuestionsQuery } from '../../question.api'
import { fetchQuestionsSelectors } from '../selectors/question.api.selectors'
import { useParams } from 'react-router'
import { useVersionId } from '../../../../utils/parseURL.helper'
import { useSelector } from 'react-redux'
import assignmentSelectors from '../../../selectors/assignment.selectors'
import { isMba } from '../../../../utils/assignment.helper'
import textSubmissionDrawerSelectors from '../../../selectors/text-submission-drawer.selectors'

export const useExplanation = answer => {
    const focusedQuestionId = useSelector(textSubmissionDrawerSelectors.focusedQuestionId)
    const { categoryIdToHighlight } = useAnswerContext()
    const { token } = useParams()

    const versionId = useVersionId()
    const type = useSelector(assignmentSelectors.type)

    const { data: question } = useFetchQuestionsQuery(
        { token, versionId },
        {
            selectFromResult: result => fetchQuestionsSelectors.byId({ id: answer?.questionId }, result),
        },
    )

    // Skip fetching explanation if:
    // 1. No category is highlighted to compare against
    // 2. The highlighted category is the same as the answer's current category (no change)
    // 3. This answer is not from the currently focused question
    // 4. For non-MBA assignments, skip if the question hasn't been trained yet
    // 5. The highlighted category is not a child of the current question
    const skip =
        isNil(categoryIdToHighlight) ||
        categoryIdToHighlight === answer?.categoryId ||
        focusedQuestionId !== answer?.questionId ||
        (!isMba(type) && !question.lastTrained) ||
        !question.categories?.some(category => category.id === categoryIdToHighlight)

    const { data: explanation, isFetching } = useFetchExplanationQuery(
        {
            answerId: answer.id,
            categoryId: categoryIdToHighlight,
        },
        {
            skip,
        },
    )

    return {
        explanation: skip || isFetching ? null : explanation,
        isFetching,
        categoryId: categoryIdToHighlight,
    }
}
